<div class="dayview">
  <table class="table table-bordered table-fixed dayview-normal-event-table">
      <tbody>
        <tr 
        *ngFor="let tm of view; trackBy: trackByFn; let tableRowIndex = index;" 
        smr-time-slot
        [timeslot]="tm"
        [tableRowIndex]="tableRowIndex"
        (timeSlotSelected)="onTimeSlotSelectedHanadler($event)"
        (calendarEventSelected)="onEventSelectedHandler($event)"
        >
      </tr>
      </tbody>
  </table>
</div>